import moment from 'moment';
import { PeriodItemValueType } from '@/features/common/raw';

export interface DayType {
  day: string,
  value: string,
}

export const getMonthInitialAndDay = (dateString: string): {
  month: string, day: number
} => {
  const date = moment(dateString, 'YYYY-MM-DD').format('MMM DD');
  const dateSplitted = date.split(' ');

  return {
    month: dateSplitted[0],
    day: +dateSplitted[1],
  };
};

export const getWeekdaysFromToday = (): DayType[] => {
  const days: DayType[] = [];
  const formatter = 'ddd, MMM DD';
  const momentDate = moment().local();

  days.push({
    day: 'Today',
    value: momentDate.format('YYYY-MM-DD'),
  });
  let i = 1;
  while (i < 7) {
    const mDate = momentDate.add(1, 'd');
    days.push({
      day: mDate.format(formatter),
      value: mDate.format('YYYY-MM-DD'),
    });
    i += 1;
  }

  return days;
};

export const getLastDateRangeFromToday = (dateString: PeriodItemValueType): {
  fromDate: string,
  toDate: string,
} => {
  const formatter = 'YYYY-MM-DD';
  let lastDay = 30;

  switch (dateString) {
    case 'Last7Days':
      lastDay = 7;
      break;
    case 'Last30Days':
      lastDay = 30;
      break;
    case 'Last60Days':
      lastDay = 60;
      break;
    case 'Last90Days':
      lastDay = 90;
      break;
    case 'Last180Days':
      lastDay = 180;
      break;
    case 'LastYear':
      lastDay = 365;
      break;
    default:
      lastDay = 30;
  }

  const fromLastMomentDate = moment().subtract(lastDay, 'd');

  return {
    fromDate: fromLastMomentDate.format(formatter),
    toDate: moment().format(formatter),
  };
};

export function calculateDateRange(dateCalendar: string[]): string[] {
  if (!dateCalendar.length) return [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];

  const fromDate = dateCalendar[0] || dateCalendar[1];
  const toDate = dateCalendar[1] || dateCalendar[0];

  return [fromDate, toDate];
}

export function formatCustomDateRangeForDisplay(customRange: string): string {
  if (!customRange || typeof customRange !== 'string') {
    return '';
  }

  const isAlreadyFormatted = /^[A-Za-z]{3}\s+\d{1,2},\s+\d{4}/.test(customRange.trim());
  if (isAlreadyFormatted) {
    return customRange;
  }

  try {
    const dateMatch = customRange.match(/(\d{4}-\d{2}-\d{2})/g);
    if (dateMatch && dateMatch.length >= 1) {
      const fromDate = dateMatch[0];
      const toDate = dateMatch[1] || fromDate;

      const fromMoment = moment(fromDate, 'YYYY-MM-DD');
      const toMoment = moment(toDate, 'YYYY-MM-DD');

      if (fromMoment.isValid() && toMoment.isValid()) {
        const formattedFromDate = fromMoment.format('MMM D, YYYY');
        const formattedToDate = toMoment.format('MMM D, YYYY');
        return `${formattedFromDate}&nbsp;&nbsp;-&nbsp;&nbsp;${formattedToDate}`;
      }
    }
  } catch (error) {
    return customRange;
  }

  return customRange;
}
